import { Link } from "react-router-dom";
import { imgSrc } from "../lib/api";
import { useLang } from "../i18n/LanguageContext";

export default function CarCard({ car, className = "", tall = false }) {
  const { t, fmtPrice, fmtNum } = useLang();

  const fuel = T_FUEL(car, t);
  const transmission = T_TR(car, t);

  return (
    <Link
      to={`/auto/${car.id}`}
      data-testid={`car-card-${car.id}`}
      className={`group block bg-paper border border-ink/5 hover:border-ink/15 transition-colors duration-500 ${className}`}
    >
      <div className={`relative overflow-hidden ${tall ? "aspect-[16/11]" : "aspect-[4/3]"}`}>
        <img
          src={imgSrc(car.images?.[0])}
          alt={`${car.brand} ${car.model}`}
          loading="lazy"
          className="w-full h-full object-cover transition-transform duration-[900ms] ease-[cubic-bezier(0.16,1,0.3,1)] group-hover:scale-[1.05]"
        />
        <span className="absolute top-4 left-4 bg-paper/90 backdrop-blur px-3 py-1.5 font-mono text-[10px] uppercase tracking-[0.2em]">
          {car.sold ? t("badge.sold") : t(`status.${car.status}`) || car.status}
        </span>
        <div className="absolute inset-x-0 bottom-0 translate-y-full group-hover:translate-y-0 transition-transform duration-500 ease-[cubic-bezier(0.16,1,0.3,1)] bg-blu/90 backdrop-blur text-white px-5 py-3 font-mono text-[11px] tracking-[0.14em] flex flex-wrap gap-x-6 gap-y-1">
          <span>{car.year}</span>
          <span>{fmtNum(car.km)} km</span>
          <span>{fuel}</span>
          <span>{transmission}</span>
        </div>
      </div>
      <div className="flex items-end justify-between gap-4 px-5 py-5">
        <div>
          <h3 className="font-display text-2xl leading-tight">
            {car.brand} <span className="italic">{car.model}</span>
          </h3>
          <p className="font-mono text-[11px] text-fog mt-1 tracking-[0.14em] uppercase">{car.year}</p>
        </div>
        <p className="font-mono text-base md:text-lg whitespace-nowrap text-blu">{fmtPrice(car.price)}</p>
      </div>
    </Link>
  );
}

const T_FUEL = (car, t) => (car.fuel && t(`fuel.${car.fuel}`) !== `fuel.${car.fuel}` ? t(`fuel.${car.fuel}`) : car.fuel || "");
const T_TR = (car, t) => (car.transmission && t(`tr.${car.transmission}`) !== `tr.${car.transmission}` ? t(`tr.${car.transmission}`) : car.transmission || "");
